const backToTop = () => {
  const timer = setInterval(function () {
    const mallHTML = document.getElementsByClassName("mall-main")[0];
    if (mallHTML) {
      const osTop = mallHTML.scrollTop;
      const ispeed = Math.floor(-osTop / 5);
      mallHTML.scrollTop = osTop + ispeed;
      if (osTop <= 0) {
        clearInterval(timer);
      }
    }
  }, 16);
};

export {
  backToTop
}